import axios from 'axios'
// import auth from '@/auth'
import store from '@/store'
import common from './common'
import HttpStatus from '@/components/http-status'
import { UniqError } from '@/models'
import FqApi from './fq-api'
import cookie from '@/cookie'
import router from '@/router'

const service = axios.create({
  baseURL: process.env.VUE_APP_WEBAPI_URI,
  responseType: 'arraybuffer'
})

service.interceptors.request.use(
  config => {
    const jwtToken = cookie.get(cookie.tokenCookieName)
    // console.log('protobuf-api', jwtToken)
    config.headers.common['Authorization'] = `Bearer ${jwtToken}`
    // console.log(config)
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  function(response) {
    return response
  },
  async function(error) {
    store.dispatch('$resetSpinner')
    let originalConfig = error.config
    originalConfig.url = originalConfig.url.replace(process.env.VUE_APP_WEBAPI_URI, '')
    // console.log(originalConfig)
    if (common.isExpiredToken(error) || common.isInvalidToken(error)) {
      // return common.refreshToken(error)
      console.log('Refreshing token')
      const newToken = await refreshToken()
      if (newToken) {
        originalConfig.headers.Authorization = `Bearer ${newToken}`
        console.log('Submitting original request')
        return service.request(originalConfig)
      } else {
        return Promise.reject(error)
      }
      // } else if (common.isInvalidToken(error) && !originalConfig.url.includes('imageuploader/signin')) {
      //   return Promise.reject(error)
      // auth.logout()
    } else if (
      error &&
      error.response &&
      error.response.status &&
      error.response.status === HttpStatus.INTERNAL_SERVER_ERROR
    ) {
      if (error.response.data instanceof ArrayBuffer) {
        const result = common.parseArrayBufferErrorResponse(error.response.data)
        store.dispatch('errors/add', result)
      } else {
        store.dispatch('errors/add', error.response.data)
      }
      console.error(error)
      return Promise.reject(error)
    } else {
      const status = error.response ? error.response.status : ''
      const statusText = error.response ? error.response.statusText : ''
      const url = error.response ? error.response.config.url : ''
      const e = new UniqError(0, statusText, status, url, error.response.data)
      store.dispatch('errors/add', e)
      console.log(e)
      return Promise.reject(error)
    }
  }
)

async function refreshToken() {
  try {
    const jwtToken = cookie.get(cookie.tokenCookieName)
    const result = await FqApi.post('/auth/imageuploader/refreshtoken', `=${jwtToken}`)
    const newToken = result.data
    store.dispatch('setJwtToken', newToken)
    return newToken
  } catch (e) {
    if (e.request && e.request.status === HttpStatus.GONE) {
      // console.error(e.request)
      cookie.delete(cookie.tokenCookieName)
      setTimeout(() => {
        router.push('/signin')
      }, 3000)
    }
    return ''
  }
}

export default service
